// «Сделать целью» из рекомендаций отчёта: открывает форму цели с подставленным значением.

import { useNavigate } from 'react-router-dom'

import { Button, Card } from '@/components/ui'

import type { ScanOut } from '../api'
import { goalLink, goalSuggestions } from './logic'

export function GoalButtons({ latest }: { latest: ScanOut | null }) {
  const navigate = useNavigate()
  const items = goalSuggestions(latest)
  if (items.length === 0) return null
  return (
    <Card title="Цели из отчёта" subtitle="У цели видна дата, когда она будет достигнута при текущем темпе">
      <ul className="divide-y divide-border">
        {items.map((s) => (
          <li key={s.kind} className="flex flex-wrap items-center justify-between gap-2 py-2">
            <span className="min-w-0 text-sm text-fg">
              <span className="font-semibold">{s.label}</span> · {s.hint}
            </span>
            <Button size="sm" aria-label={`Сделать целью: ${s.label}`} onClick={() => navigate(goalLink(s))}>
              Сделать целью
            </Button>
          </li>
        ))}
      </ul>
    </Card>
  )
}
